const secondsToHms = (seconds: number) => ({
    h: Math.floor(seconds / 3600),
    m: Math.floor((seconds % 3600) / 60),
    s: Math.floor((seconds % 3600) % 60),
});

export default secondsToHms;
